import { Navigate, Outlet, useLocation, matchPath } from "react-router-dom";
import menuItems from "../common/sidebar/sidebar.json";
import useAbility from "../hooks/useAbility";

const isAuthenticated = () => {
  try {
    const token = localStorage.getItem("access_token");
    return !!token; 
  } catch {
    return false;
  }
};

const sidebarRoutePermissions = menuItems.reduce((acc, item) => {
  (item.subMenu || []).forEach((subItem) => {
    if (subItem?.path && subItem?.permissionKey) {
      acc[subItem.path] = subItem.permissionKey;
    }
  });
  return acc;
}, {});

const additionalRoutePermissions = {
  "/user-update/:id": "addUser",
  "/warehouse-update/:id": "addWarehouse",
  "/warehouse-products/:id": "viewWarehouse",
  "/product-update/:id": "addProduct",
  "/assign-product/:id": "assignProduct",
  "/label-list/:date": "viewLablel",
  "/workflow-list/:date": "approveWorkflow",
  "/tracking-list/:date": "viewTracking",
  "/calculation-list/:id": "viewCalculation",
  "/leasure-list-detail/:id": "viewLeasure",
  "/service-update/:id": "addService",
  "/hero-update/:id": "addHero",
  "/package-update/:id": "addPackage",
};

const routePermissions = {
  ...sidebarRoutePermissions,
  ...additionalRoutePermissions,
};

const getRequiredPermission = (pathname) => {
  const normalizedPath =
    pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

  const matchedRoute = Object.entries(routePermissions).find(([routePath]) =>
    matchPath({ path: routePath, end: true }, normalizedPath)
  );

  return matchedRoute?.[1];
};


const PublicRoutes = () => {
  const location = useLocation();
  return isAuthenticated()
    ? <Navigate to="/" state={{ from: location }} replace />
    : <Outlet />;
};

const PrivateRoutes = () => {
  const ability = useAbility();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/auth-signin" state={{ from: location }} replace />;
  }

  const requiredPermission = getRequiredPermission(location.pathname);
  if (!requiredPermission) {
    return <Outlet />;
  }

  if (ability.can("manage", "all") || ability.can(requiredPermission, "all")) {
    return <Outlet />;
  }

  return <Navigate to="/auth-403" state={{ from: location }} replace />;
};


// const PrivateRoutes = () => {
//   const location = useLocation();
//   const ability = useAbility();

//   if (!isAuthenticated()) {
//     return <Navigate to="/auth-signin" state={{ from: location }} replace />;
//   }

//   const requiredPermission = routePermissions[location.pathname];
//   if (requiredPermission && !ability.can(requiredPermission, "all")) {
//     return <Navigate to="/auth-403" replace />;
//   }

//   return <Outlet />;
// };

export { PublicRoutes, PrivateRoutes };
